module.exports = __webpack_public_path__ + "img/logo LC-new CI.745e4e71.svg";